import request from '@/utils/requestRFID';
import request_noLoading from '@/utils/requestRFID_noLoading';

/**
 * 
 * 
 *  RFID USB WRITER
 * 
 * 
 **/

// connect to rfid
export function RFIDConnect(port) {
  return request({
    url: `/ConnectComPort/${port}`,
    method: 'get'
  })
}

// disconnect from rfid
export function RFIDDisconnect() {
  return request({
    url: `/disconnect`,
    method: 'get'
  })
}

// get available com ports
export function RFIDGetAvailablePorts() {
  return request({
    url: '/ListAvailableComPorts',
    method: 'get'
  })
}

// get connection state
export function RFIDGetConnectionState() {
  return request({
    url: '/GetConnectionState',
    method: 'get'
  })
}

// get connection port name
export function RFIDGetPortName() {
  return request({
    url: '/GetPortName',
    method: 'get'
  })
}

// read epc tag
export function RFIDRead() {
  return request({
    url: '/Read',
    method: 'get'
  })
}

// write epc data
export function RFIDWrite(data) {
  return request({
    url: `/Write/${data}`,
    method: 'get'
  })
}

/**
 * 
 * 
 * ZEBRA RFD8500
 * 
 */


// getting bluetooth readers
export function getBluetoothReaders() {
  return request({
    url: `/GetBluetoothReaders`,
    method: 'get'
  })
}

// refreshing bluetooth readers
export function refreshBluetoothReaders() {
  return request({
    url: `/RefreshBluetoothReaders`,
    method: 'get'
  })
}

// select bluetooth reader
export function selectZebraConnection(id) {
  return request({
    url: `/SelectZebraConnection/${id}`,
    method: 'get'
  })
}

// check if bluetooth reader is connected
export function getZebraConnectionStatus() {
  return request({
    url: `/IsZebraConnected`,
    method: 'get'
  })
}

// connect to selected bluetooth reader
export function connectZebra() {
  return request({
    url: `/ConnectZebra`,
    method: 'get'
  })
}

// disconnect selected bluetooth reader
export function disconnectZebra() {
  return request({
    url: `/DisconnectZebra`,
    method: 'get'
  })
}

/* INVENTORY */

// start zebra rfid inventory
export function startInventory() {
  return request({
    url: `/StartInventory`,
    method: 'get'
  })
}

// stop zebra rfid inventory
export function stopInventory() {
  return request({
    url: `/StopInventory`,
    method: 'get'
  })
}

// stop zebra rfid inventory
export function getInventoryStatus() {
  return request_noLoading({
    url: `/GetInventoryStatus`,
    method: 'get'
  })
}

// get zebra rfid tag data
export function getTagData() {
  return request_noLoading({
    url: `/GetTagData`,
    method: 'get'
  })
}

/* TAG LOCATION */

// start zebra rfid tag locate
export function startTagLocate(epc) {
  return request({
    url: `/StartTagLocate/${epc}`,
    method: 'get'
  })
}

// stop zebra rfid tag locate
export function stopTagLocate() {
  return request({
    url: `/StopTagLocate`,
    method: 'get'
  })
}

// get zebra rfid tag locate state
export function getTagLocateStatus() {
  return request_noLoading({
    url: `/GetTagLocateStatus`,
    method: 'get'
  })
}

// get zebra rfid tag locate percentage
export function getTagLocatePercentage() {
  return request_noLoading({
    url: `/GetTagLocatePercentage`,
    method: 'get'
  })
}



/* CONFIG */

// get zebra rfid reporting config
export function getRFIDReportingConfig() {
  return request_noLoading({
    url: `/GetTagReportingConfig`,
    method: 'get'
  })
}

// get zebra rfid trigger config
export function getTriggerInfoConfig() {
  return request_noLoading({
    url: `/GetTriggerInfoConfig`,
    method: 'get'
  })
}

// get zebra rfid device info
export function getDeviceInfo(){
  return request_noLoading({
    url: `/GetDeviceInfo`,
    method: 'get'
  })
}

// get zebra rfid device info for first hello
export function getDeviceInfoInstant(){
  return request_noLoading({
    url: `/getDeviceInfoInstant`,
    method: 'get'
  })
}

